.toolbar {
  flex: 1;
  position: relative; /* for `z-index` below, in case parent doesn't have `display: flex` */
  z-index: 1; /* for toolbar menus to appear above visualizations (overflow, selectors) */
  display: flex;
  min-width: 0;
  height: var(--h5w-toolbar--height, 2.5rem);
  padding: 0 0.5rem;
  background-color: var(--h5w-toolbar--bgColor, aliceblue);
  font-size: 0.875rem;
}

.controls {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  min-width: 0;
}

.controlWrapper[data-measured='false'] {
  position: relative;
  overflow: hidden; /* hide controls while they are being measured */
}

.controlWrapper[data-measured='false'] > .control {
  position: absolute;
}

.controlWrapper,
.control {
  display: flex;
}

.sep {
  margin: 0.375rem 0.25rem;
  border-left: 1px solid var(--h5w-toolbar-separator--color, rgba(0, 0, 0, 0.2));
}

.btn {
  composes: btn from './utils.module.css';
}

.btnLike {
  composes: btnLike from './utils.module.css';
}

.icon {
  composes: icon from './utils.module.css';
}

.label {
  composes: label from './utils.module.css';
}

.arrowIcon {
  align-self: center;
  margin-top: 1px;
  margin-left: 1px;
  margin-right: -0.25rem;
  color: var(--h5w-selector-arrowIcon--color, dimgray);
  font-size: 1.25em;
}

.btn[aria-expanded='true'] .arrowIcon {
  transform: rotate(180deg);
}

.popup {
  composes: popup from './utils.module.css';
}

.menu {
  composes: menu from './utils.module.css';
}

.btnOption {
  composes: btnClean from './utils.module.css';
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  line-height: 1.5em; /* same as icon, if any */
  transition: background-color 0.05s ease-in-out;
  white-space: nowrap;
}

.btnOption:hover,
.btnOption[data-active] {
  background-color: var(--h5w-selector-option-hover--bgColor, whitesmoke);
}

.btnOption:focus-visible {
  outline: 1px solid var(--h5w-selector-option-focus--outlineColor, gray);
  outline-offset: -1px;
}

.btnOption[aria-selected] {
  background-color: var(--h5w-selector-option-selected--bgColor, #eee);
}
